/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

const trackingUtils = require('../utils/tracking.utils');
const parserAccResultsManager = require('../parsers/accommodation_results_manager');

function renderWithFilterTags() {
    this.$cachedSelectors.filterSummaryContainer.html(this.tmpls.filterTags(parserAccResultsManager.getFilterTagsData(this.model, this.opts)));
}

function toggleClasses(hasZeroResults, hasFilteredResults) {
    this.$cachedSelectors.zeroResultsPanel.toggleClass('odf-hidden', !hasZeroResults);
    this.$cachedSelectors.filteredResultsPanel.toggleClass('odf-hidden', !hasFilteredResults);
    this.$cachedSelectors.xsellFlightSelectionHeader.toggleClass('odf-hidden', hasZeroResults);
    this.$el.toggleClass('odf-hidden', !(!hasFilteredResults || !hasZeroResults) || !!this.opts.hasToHideAppliedFilters);
}

function completeFields(numResults, numFilteredResults, cheapestPrice) {
    this.$cachedSelectors.numResultsInfo.text(numResults);
    this.$cachedSelectors.numFilteredResultsInfo.text(numFilteredResults);
    this.$cachedSelectors.cheapestPrice.html(cheapestPrice);
}

function renderDefaultView() {
    var numFilteredResults = this.model.get('numFilteredResults');
    var numResults = this.model.get('numResults');
    var cheapestAccPrice = this.model.get('cheapestAccommodationPrice');
    var hasZeroResults = numFilteredResults === 0;
    var nDecimals = ('' + cheapestAccPrice).split('.').length === 1 ? 0 : 2;
    var cheapestPrice = Odigeo.Utils.formatCurrency(
        cheapestAccPrice,
        Odigeo._.extend({}, Odigeo.Utils.Currency, {
            decimalPlaces: nDecimals,
        })
    );
    var hasFilteredResults = !hasZeroResults && numResults !== numFilteredResults;

    completeFields.call(this, numResults, numFilteredResults, cheapestPrice);
    toggleClasses.call(this, hasZeroResults, hasFilteredResults);
}

function hasNoResultsByFiltering() {
    var numFilteredResults = this.model.get('numFilteredResults');
    var numResults = this.model.get('numResults');

    return Odigeo._.gt(numResults, 0) && Odigeo._.eq(numFilteredResults, 0);
}

module.exports = Odigeo.View.extend({
    ignoreModelUpdate: false,

    selectors: {
        filteredResultsPanel: '.accommodation_filtered_results',
        zeroResultsPanel: '.accommodation_zero_filtered_results',
        loadingResultsPanel: '.accommodation_loading_results',
        summaryResultsPanel: '.accommodation_summary_results',
        numFilteredResultsInfo: '.accommodation_num_filtered',
        numResultsInfo: '.accommodation_num_accommodations',
        resetButton: '.reset_filter_accommodations',
        cheapestPrice: '.accommodation_cheapest_price',
        filterSummaryContainer: '.accommodation_filters_summary',
        xsellFlightSelectionHeader: '.xsell_flight_selection_header',
    },

    tmpls: {
        filterTags: '.accommodation_filters_summary_template',
    },

    events: {
        'tap @resetButton': 'resetFilterButtonClicked',
        'tap .reset_filter_no_results_accommodations': 'resetFilterButtonClicked',
        'tap .reset_filter_tag': 'resetFilterTag',
    },

    init: function() {
        this.opts = Odigeo.parseOptions(this.widget.options);
        this.tmpls = Odigeo.Utils.getTemplates(this.$el, this.tmpls);
    },

    resetFilterButtonClicked: function(ev) {
        var undoFilteringType = $(ev.target).data('noResults') ? 'no_results_found' : 'tags';

        Odigeo.trigger(this.widget.id + ':resetFiltersClicked');
        trackingUtils.trackEvent('results_filters_hotels', 'undo_filtering_hotels_' + undoFilteringType);
    },

    resetFilterTag: function(ev) {
        var nameTag = $(ev.target).data('tag');
        var tag = this.model.get('activatedTags')[nameTag] || {};

        trackingUtils.trackEvent('results_filters_hotels', 'remove_filter_' + nameTag.toLowerCase());
        Odigeo.trigger(this.widget.id + ':resetFilterTag', {
            name: nameTag,
            type: tag.type,
        });
    },

    render: function() {
        if (this.opts.hasActivedTags) {
            renderWithFilterTags.call(this);
        } else {
            renderDefaultView.call(this);
        }
    },

    postRender: function() {
        if (hasNoResultsByFiltering.call(this)) {
            trackingUtils.trackEvent('results_filters_hotels', 'filtering_hotels_no_results_found');
        }
    },

    loadSummary: function(isLoading) {
        this.$cachedSelectors.summaryResultsPanel.toggleClass('refreshing-results', isLoading);
    },
});
